import React, { type FC, useEffect, useState } from 'react';

import cn from 'classnames';
import { debounce } from 'lodash';

export const SelectWithOther: FC<{
  option?: string;
  disabled?: boolean;
  hideOther?: boolean;
  options: string[];
  placeholder: string;
  onSelect(reason: string): void;
}> = ({ option, disabled, hideOther, options, placeholder, onSelect }) => {
  let onOther = (reason: string) => onSelect(reason);
  onOther = debounce(onOther, 200);
  const [open, setOpen] = useState(false);

  useEffect(() => {
    if (!open) return;
    const listener = () => setOpen(false);
    document.addEventListener('click', listener);
    return () => document.removeEventListener('click', listener);
  }, [open]);

  return (
    <div className="btn-group select-with-other">
      <div className={cn('dropdown', open && 'open')}>
        <button
          disabled={disabled}
          type="button"
          className="btn btn-default dropdown-toggle"
          onClick={(event) => {
            event.preventDefault();
            event.stopPropagation();
            setOpen((open) => !open);
          }}
        >
          {option ?? placeholder} <span className="caret" />
        </button>
        <ul
          className="dropdown-menu"
          onClick={(event) => {
            event.stopPropagation();
            event.preventDefault();
          }}
        >
          {options.map((option) => (
            <li key={option}>
              <a
                href="#"
                onClick={(event) => {
                  event.preventDefault();
                  event.stopPropagation();
                  onSelect(option);
                  setOpen(false);
                }}
              >
                {option}
              </a>
            </li>
          ))}
          {!hideOther && (
            <>
              <li role="separator" className="divider" />
              <li>
                <input
                  onChange={(event) => onOther(event.target.value)}
                  className="form-control"
                  type="text"
                  placeholder="Other"
                />
              </li>
            </>
          )}
        </ul>
      </div>
    </div>
  );
};
